module.exports = __webpack_public_path__ + "static/media/cancel.b7cc66bc.svg";